<template>
  <div>
    <div>
      <div>
        <header
          class="mb-8 border-b border-header-border bg-header-background sm:mb-10"
        >
          <div class="container m-auto">
            <div class="flex items-center justify-between px-4">
              <div class="py-4" data-test-id="page-header-logo">
                <UISkeletonBlock class="sm:h-30 block h-9 w-24" />
              </div>
              <aside
                class="aside flex items-center gap-4"
                data-test-id="page-header-actions"
              >
                <UISkeletonBlock class="sm:h-30 block size-9" />
              </aside>
            </div>
          </div>
        </header>
        <main class="container mx-auto px-4">
          <UIColumnLayout>
            <UISkeletonBlock class="mb-4 h-8 w-1/2" />
            <UISkeletonBlock class="h-64 rounded-2" />

            <template #aside>
              <div class="mt-12 flex flex-col gap-4">
                <UISkeletonBlock class="h-60 rounded-2" />
                <UISkeletonBlock class="h-24 rounded-2" />
                <UISkeletonBlock class="h-24 rounded-2" />
              </div>
            </template>
          </UIColumnLayout>
        </main>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import UIColumnLayout from '@booking-portal/modules/ui/components/UIColumnLayout.vue';
import UISkeletonBlock from '@booking-portal/modules/ui/skeletons/components/UISkeletonBlock.vue';
</script>

<style scoped lang="scss"></style>
